import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className = "", y = 28 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", as: Tag = "span" }) {
  return (
    <span className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay: 0.2 + i * 0.13, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function SectionHead({ index, eyebrow, title, dark = false, align = "left" }) {
  return (
    <Reveal className={`mb-10 md:mb-14 ${align === "center" ? "text-center" : ""}`}>
      <div className={`flex items-baseline gap-4 ${align === "center" ? "justify-center" : ""}`}>
        {index && (
          <span className={`font-mono text-xs tracking-[0.2em] ${dark ? "text-[#8C7B5D]" : "text-[#8C7B5D]"}`}>
            {index}
          </span>
        )}
        <p className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.28em] ${dark ? "text-[#9A968C]" : "text-[#5A5D64]"}`}>
          {eyebrow}
        </p>
      </div>
      <h2
        className={`mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold uppercase tracking-tight leading-[0.95] ${
          dark ? "text-[#F6F3EB]" : "text-[#121212]"
        }`}
      >
        {title}
      </h2>
    </Reveal>
  );
}
